import React, { Component } from 'react'
import {captcha} from '../../config'
//let ReCAPTCHA = null
import ReCAPTCHA from 'react-google-recaptcha'
//let mod = null
//let lang = null
class Captcha extends Component {
    /*
  constructor(props) {
    super(props);
    this.state = { isReady: ReCAPTCHA !== null };
  }*/
  /*
componentWillMount() {
	if(this.props.lang!==lang) {
		console.log('changed lang')
		console.log(mod)
		lang = this.props.lang
		this.setState({isReady: false})
		ReCAPTCHA = null
		if(mod) {
			console.log('delete cache')
			delete require.cache[require.resolve('./recaptcha')]
			mod = null
		}
	}
}
  */
    /*
  componentDidMount() {
  	require.ensure('./recaptcha', () => {
  		//console.log('loaded cap')
  		//mod = require.resolve('./recaptcha')
  		//console.log(mod)
            ReCAPTCHA = require('./recaptcha').default;
            console.log(ReCAPTCHA)
      if (!this.hasUnmounted) {
        this.setState({ isReady: true });
      }
    });
  }*/
  
  componentWillUnmount() {
    this.hasUnmounted = true;
  }

    render() {
        return <ReCAPTCHA sitekey={captcha} onChange={value => this.props.onChange(value)} />
            /*
  	return this.state.isReady 
  		? <ReCAPTCHA sitekey={captcha} onChange={value => this.props.onChange(value)} /> 
  		: null*/
  }
}
export default Captcha;



// WEBPACK FOOTER //
// ./src/fm/lib/Captcha.js